<app-header></app-header>

<section class="login">
  <app-forgotten-password-form></app-forgotten-password-form>
</section>
